import { render } from "./RightMenu.vue?vue&type=template&id=493b86f6"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__